import { render, staticRenderFns } from "./deleteIntegralShopRule.vue?vue&type=template&id=55508d98"
import script from "./deleteIntegralShopRule.vue?vue&type=script&lang=js"
export * from "./deleteIntegralShopRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports